import { CmsContentListResponse } from "../models/response/CMSResponse";
import cmsApi from "../api/cms.api";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";


export const cmsService = {
    getCmsContentByPageName: async (pageName: string): Promise<UnifiedResponse<CmsContentListResponse>> => {
        return cmsApi.getPromotionByPageUrl(pageName);
    },
}

export default cmsService;



